import React, { Component } from 'react';
import { Modes, LayoutStyles } from 'config';

const Cart = () => <span></span>;
const Modal = Cart;
const ModalContent = Cart;

const getIsCartEnabled = (props) => {
  if (props.isProductPage) {
    return props.isCartEnabled;
  }
  return props.profile.isCartEnabled;
};

const getIsShowCartModal = (props) => props.isShowCartModal;

const ensureCart = (DecorateComponent) => {
  class DecoratedComponent extends Component {
    constructor() {
      super();
      this.state = {
        Modal,
        Cart,
        ModalContent,
      };
    }

    componentDidMount () {
      if (typeof this.props.handleToggleCartModal !== 'function') {
        throw new Error('HoC `ensureCart` expects dispatched `handleToggleCartModal` to be passed in');
      }
    }

    componentWillReceiveProps (nextProps) {
      const isCartEnabled = getIsCartEnabled(nextProps);

      if (isCartEnabled) {
        require.ensure([], (require) => {
          const Cart = require('Cart').default;
          const ModalView = require('views/Modal');
          const Modal = ModalView.default;
          const ModalContent = ModalView.ModalContent;

          this.setState({
            Cart,
            Modal,
            ModalContent,
          });
        }, 'cart');
      }
    }

    render () {
      const isCartEnabled = getIsCartEnabled(this.props);
      const isShowCartModal = getIsShowCartModal(this.props);

      const { Cart, Modal, ModalContent } = this.state;

      return (
        <div>
          <DecorateComponent {...this.props} />
          { isCartEnabled ?
            <Modal
              show={isShowCartModal}
              backdropStyle={{ background: 'rgba(241, 244, 242, 0.94)' }}
              >
              <ModalContent
                style={LayoutStyles}
                modalClose={{
                  onRequestClose: () => this.props.handleToggleCartModal(),
                  style: {
                    color: '#afafaf',
                    right: '5px',
                    top: '9px',
                  },
                }}>
                <div style={{ marginBottom: '48px' }}>
                  <Cart mode={Modes.FULL} />
                </div>
              </ModalContent>
            </Modal> :
            null
          }
        </div>
      );
    }
  }

  // for waggle
  // static methods get lost with HoC
  // so replugging `endpoint` back with this component
  const { endpoint } = DecorateComponent;
  return Object.assign(DecoratedComponent, { endpoint });
};

export default ensureCart;



// WEBPACK FOOTER //
// ./src/common/decorators/Cart.js